module.exports = __webpack_public_path__ + "img/plus_btn.bb41f133.png";